import { SITE } from '@/app/constants';
import type { ProductPlan, SubscriptionProductType, SubsPlanType, SupportedLanguage } from '@/app/types';
import { formatPriceDiscount } from '@/app/utils';
import {
  CREDITS_CONFIG_LIST,
  type IndividualPlanType,
  MAX_PLAN_VIDEOS,
  NEW_MEMBERSHIP_ULTIMATE_CREDITS,
} from './constants';

export type UltimateProductOption = { product: SubscriptionProductType; credits: number };

export const getUltimateProductOptions = (product?: ProductPlan['ultimate_v2']): UltimateProductOption[] =>
  [...(product?.variants ?? [])]
    .sort((a, b) => (a.original_price || a.price) - (b.original_price || b.price))
    .map((product, index) => ({
      product,
      credits: index === 0 ? NEW_MEMBERSHIP_ULTIMATE_CREDITS.base : NEW_MEMBERSHIP_ULTIMATE_CREDITS.higher,
    }));

export const getCreditsDiscount = (planType: SubsPlanType, locale: SupportedLanguage) => {
  if (planType === 'ultimate_v2') return formatPriceDiscount(55, locale);
  if (SITE === 'china') return '5.5';
  return formatPriceDiscount(45, locale);
};

/**
 * 计算积分块刻度进度条亮色填充比例。
 * = 当前 plan videos / 所有付费 plan 最大 videos × 100
 * 返回 0-100 的整数百分比。
 */
export const getCreditsProgress = (planType: IndividualPlanType): number => {
  const videos = CREDITS_CONFIG_LIST[planType].videos;
  if (typeof videos !== 'number' || MAX_PLAN_VIDEOS <= 0) return 0;
  return Math.min(100, Math.round((videos / MAX_PLAN_VIDEOS) * 100));
};
